import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { experiences } from '../data';
import './RequestBookingPage.css';

const BOOKING_FORM_URL =
  'https://frontal-firestorm-840.forms.space/request-booking-s425cb';

const RequestBookingPage = () => {
  const { id } = useParams();

  const experience = experiences.find((item) => item.id === id);

  const bookingFormUrl = new URL(BOOKING_FORM_URL);

if (experience) {
  bookingFormUrl.searchParams.set(
    'prefill.experienceName',
    experience.name
  );

  bookingFormUrl.searchParams.set(
    'prefill.experienceLocation',
    `${experience.city}, ${experience.state}`
  );
}

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });
  }, [id]);

  if (!experience) {
    return (
      <main className="booking-page booking-not-found">
        <section className="booking-not-found-card">
          <p className="booking-eyebrow">Request Booking</p>

          <h1>We couldn’t find that experience.</h1>

          <p>
            The listing may have moved or may no longer be available.
          </p>

          <Link to="/browse" className="booking-primary-button">
            Browse All Options
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="booking-page">
     
<section className="booking-page-heading">
  <p className="booking-eyebrow">Request Booking</p>

  <h1>Let’s start planning your team experience.</h1>
</section>


      <section className="booking-layout">
        <aside className="booking-experience-card">
          <Link
            to={`/business/${experience.id}`}
            className="booking-back-link"
          >
            ← Back to experience
          </Link>

          <img
            src={experience.image}
            alt={experience.name}
            className="booking-experience-image"
          />

          <div className="booking-experience-content">
            <p className="booking-location">
              {experience.city}, {experience.state}
            </p>

            <h2>{experience.name}</h2>

            <p className="booking-summary">
              {experience.summary}
            </p>

            <div className="booking-facts">
              <span>{experience.groupSize} people</span>
              <span>{experience.duration}</span>
              <span>{experience.price}</span>
              <span>{experience.setting}</span>
            </div>

            <div className="booking-reminder">
              <strong>This is a booking request.</strong>

              <p>
                Your event is not confirmed until availability, pricing, and
                details have been approved.
              </p>
            </div>
          </div>
        </aside>

        <section className="booking-form-card">
         <header className="booking-form-header">
  <div>
    <h2>Request {experience.name}</h2>

  
  </div>
</header>

                  <p className="booking-free-note">
 <strong>No fee to submit a request.</strong> Office Outing will coordinate
    the booking, and once availability, pricing, and details are approved,
    you’ll receive the final price and payment instructions.
</p>


          <iframe
            src={bookingFormUrl.toString()}
            title={`Request booking for ${experience.name}`}
            className="booking-form-embed"
            frameBorder="0"
            loading="lazy"
          />

          <aside className="booking-next-card">
            <span aria-hidden="true">✓</span>

            <div>
              <h3>What happens next?</h3>

              <p>
                Office Outing will coordinate your request with the provider
                and keep you updated by email.
              </p>
            </div>
          </aside>
        </section>
      </section>
    </main>
  );
};

export default RequestBookingPage;
